<template>
    <form-container :header-text="titel" :width="450" :action="action" :valid-actions="['passDuplikat']"
                    header-icon="mdi-card-account-details" @save="save()"
                    :button-ok="formSettings.buttonOk" :button-cancel="formSettings.buttonCancel"
                    :buttonOkColor="formSettings.buttonOkColor">
        <v-card-text v-if="actionObject &&
                    (!actionObject.spieler.passNr || actionObject.spieler.passNr==='ummeldung')" class="px-6">
            Für Mitglied <span class="font-weight-bold primary--text">{{actionObject.spieler.vorname}}
            {{actionObject.spieler.nachname}}</span> gibt es leider keinen Pass, der aktuell gültig ist.<br>
            Du kannst daher kein Duplikat anfordern!
        </v-card-text>
        <v-card-text v-else-if="actionObject && actionSettings && !actionSettings.pending" class="px-6">
            Möchstes du wirklich für  <span class="font-weight-bold primary--text">{{actionObject.spieler.vorname}}
            {{actionObject.spieler.nachname}}</span>
            (Pass-Nr. <span class="font-weight-bold">{{actionObject.spieler.passNr}}</span>)
            ein Pass-Duplikat anfordern?
        </v-card-text>
        <v-card-text v-else-if="actionObject && actionSettings && actionSettings.pending && !blockRefresh" class="px-6">
            <p>Du hast für <span class="font-weight-bold warning--text">{{actionObject.spieler.vorname}}
            {{actionObject.spieler.nachname}}</span>
            (Pass-Nr. <span class="font-weight-bold">{{actionObject.spieler.passNr}}</span>)
                bereits vor <span class="font-weight-bold warning--text">{{timeSince}}</span>
                ein Pass-Duplikat angefordert.</p>
            <p><span class="font-weight-bold">Dieses Duplikat ist vom Passreferenten
                noch nicht ausgestellt worden!</span></p>
            <p> Möchstest du die Anforderung stornieren?</p>
        </v-card-text>
    </form-container>
</template>

<script>
    import FormContainer from "../../../components/form/formContainer";
    import SpielerActionIconList from "../../../services/data/spielerActionIcons/spielerActionIconList";
    import TimeStamp from "../../../services/timeStamp";

    export default {
        components: {FormContainer},
        name: "spieler-pass-duplikat",
        props: ['action', 'actionObject'],
        data: () => ({
            blockRefresh: false,
        }),
        computed: {
            pendingActions() { return this.$store.state.realtime.pendingActions },
            actionSettings () { return this.actionObject ? SpielerActionIconList.passDuplikat(
                                    this.actionObject.local.spieler, this.pendingActions) : null},
            titel() { return this.actionSettings && this.actionSettings.pending ?
                            'Pass-Duplikat stornieren' : 'Pass-Duplikat beantragen'},
            formSettings() {
                return this.actionObject && !this.actionObject.spieler.passNr ?
                    {   buttonOkColor: '',
                        buttonOk: 'ok',
                        buttonCancel: '',
                    }
                    :
                    this.actionSettings ?
                    {   buttonOkColor: !this.actionSettings.pending? 'primary' : 'warning',
                        buttonOk: !this.actionSettings.pending? 'Ja' : 'endgültig stornieren',
                        buttonCancel: !this.actionSettings.pending? 'Nein' : 'abbrechen',
                    } :
                    {   buttonOkColor: 'primary',
                        buttonOk: 'Ja',
                        buttonCancel: 'Nein',
                    };
            },
            timeSince(){
                return this.actionSettings ?
                 TimeStamp.getTimeSince(this.actionSettings.pending.createdAt) : '';
            }
        },
        methods: {
            save(){
                if ( !this.actionObject.spieler.passNr  ) {
                    window.history.back();
                } else if ( this.actionSettings.pending ) {
                    this.cancelAction();
                } else {
                    this.saveNew();
                }
            },
            saveNew(){
                this.blockRefresh = true;
                setTimeout(()=>{ this.blockRefresh = false },1000);
                this.actionObject.setEditPending();
                this.actionObject.autoConfirmDuplicateAndContentChanges()
                this.$emit('saveAction', this.actionObject,
                    { success: 'Das Passduplikat wurde erfolgreich beantragt!'}, true, true
                );
                window.history.back();
            },
            cancelAction(){
                this.$emit('cancelAction', this.actionSettings.pending, this.actionObject);
                window.history.back();
            },
        },
    }
</script>

<style scoped>

</style>